import { render, staticRenderFns } from "./MyQuestionBank.vue?vue&type=template&id=335630da&scoped=true"
import script from "./MyQuestionBank.vue?vue&type=script&lang=js"
export * from "./MyQuestionBank.vue?vue&type=script&lang=js"
import style0 from "./MyQuestionBank.vue?vue&type=style&index=0&id=335630da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335630da",
  null
  
)

export default component.exports